module.exports = __webpack_public_path__ + "img/photo2.ab8611e8.png";